// @flow

export function isOlderThanSeconds (isoDate: string, seconds: number): any {
  return !isYoungerThanSeconds(isoDate, seconds)
}

export function isYoungerThanSeconds (isoDate: string, seconds: number): any {
  const timestamp = new Date(isoDate)
  const now = new Date(Date.now())
  now.setSeconds(now.getSeconds() - seconds)
  return (timestamp > now)
}
